import {FeatureFlags} from "@/pb/api/devplan/types/config";

export const PAID_OR_TRIAL_ORG_FEATURE_FLAG_VALUE = "-2";

/**
 * Checks if a feature flag is enabled based on a custom checker function.
 */
export function isFeatureFlagEnabled(
  flags: FeatureFlags | undefined,
  checker: (ff: FeatureFlags) => boolean
): boolean {
  return flags !== undefined && checker(flags);
}

/**
 * Checks if a feature flag is enabled for a specific company.
 * Supports global enablement if the flag value is ["-1"] and paid/trial
 * organization enablement with "-2" when eligibility is confirmed by caller.
 */
export function isCompanyFeatureFlagEnabled(
  flags: FeatureFlags | undefined,
  companyId: number | undefined,
  flagSelector: (ff: FeatureFlags) => string[],
  paidOrTrialOrgEligible = false
): boolean {
  if (flags === undefined) {
    return false;
  }
  const flagVal = flagSelector(flags);
  if (!flagVal || flagVal.length === 0) {
    return false;
  }
  // "-1" signifies globally enabled for all companies
  if (flagVal.length === 1 && flagVal[0] === "-1") {
    return true;
  }
  if (!companyId) {
    return false;
  }
  if (flagVal.includes(`${companyId}`)) {
    return true;
  }
  return flagVal.includes(PAID_OR_TRIAL_ORG_FEATURE_FLAG_VALUE) && paidOrTrialOrgEligible;
}
